const map = {
	"./Bandido.js": [
		4815,
		[
			631,
			672,
			849,
			186,
			728,
			198,
			819,
			815
		]
	],
	"./CherryBlast.js": [
		3301,
		[
			631,
			186,
			728,
			198,
			819,
			301
		]
	],
	"./DragonTiger.js": [
		3744,
		[
			631,
			186,
			728,
			198,
			819,
			744
		]
	],
	"./DueloMahjong.js": [
		6738,
		[
			631,
			227,
			186,
			728,
			198,
			819,
			403,
			738
		]
	],
	"./EmberInferno.js": [
		8889,
		[
			631,
			227,
			186,
			728,
			198,
			819,
			889
		]
	],
	"./EmpireOfTheTiger.js": [
		8725,
		[
			631,
			227,
			672,
			186,
			728,
			198,
			819,
			403,
			725
		]
	],
	"./FishingJackpots.js": [
		179,
		[
			631,
			227,
			672,
			186,
			728,
			198,
			819,
			403,
			179
		]
	],
	"./FishyCatch.js": [
		4134,
		[
			631,
			227,
			186,
			728,
			198,
			819,
			403,
			134
		]
	],
	"./FishyGuy.js": [
		4230,
		[
			631,
			227,
			186,
			728,
			198,
			819,
			230
		]
	],
	"./GoldOfEgypt.js": [
		5810,
		[
			631,
			227,
			672,
			186,
			728,
			810
		]
	],
	"./JokersFortune.js": [
		2697,
		[
			631,
			672,
			186,
			728,
			198,
			819,
			697
		]
	],
	"./JokersShow.js": [
		4420,
		[
			631,
			672,
			186,
			728,
			198,
			819,
			420
		]
	],
	"./KraljBalkana.js": [
		1778,
		[
			631,
			186,
			728,
			198,
			819,
			778
		]
	],
	"./NedAndTed.js": [
		8142,
		[
			631,
			227,
			186,
			728,
			198,
			819,
			403,
			142
		]
	],
	"./PremierSlot.js": [
		1232,
		[
			631,
			227,
			186,
			728,
			198,
			819,
			232
		]
	],
	"./RandysRevenge.js": [
		3096,
		[
			631,
			227,
			186,
			728,
			96
		]
	],
	"./RedZoneRumble.js": [
		8856,
		[
			631,
			672,
			186,
			728,
			198,
			819,
			403,
			856
		]
	],
	"./Slot.js": [
		5954,
		[
			631,
			227,
			672,
			260,
			186,
			198,
			954
		]
	],
	"./SugarBlast.js": [
		8042,
		[
			631,
			227,
			186,
			728,
			198,
			819,
			42
		]
	],
	"./SuperCup.js": [
		1080,
		[
			631,
			672,
			186,
			728,
			198,
			819,
			80
		]
	],
	"./Supernova.js": [
		366,
		[
			631,
			186,
			728,
			198,
			819,
			366
		]
	],
	"./TaleOfGems.js": [
		3758,
		[
			631,
			186,
			728,
			198,
			819,
			758
		]
	],
	"./TolucaFortune.js": [
		5183,
		[
			631,
			227,
			186,
			728,
			198,
			819,
			183
		]
	],
	"./Wheel.js": [
		821,
		[]
	],
	"./WildAce.js": [
		5173,
		[
			631,
			672,
			186,
			728,
			198,
			819,
			403,
			173
		]
	],
	"./index.js": [
		9992,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 951;
module.exports = webpackAsyncContext;